module.exports = __webpack_public_path__ + "static/media/business-icon@3x.ee5ad140.png";